'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dLogin$002dPath$0024$0024anon$0024124 from "./presto.types$-Site-Login-Path$$anon$124.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteLoginPath$() {
  this.caL = null;
  this.caM = false;
  this.caJ = null;
  this.caK = false;
  this.caN = null;
  this.caO = false;
}
export { $c_Lpresto_types$SiteLoginPath$ as $c_Lpresto_types$SiteLoginPath$ };
$p = $c_Lpresto_types$SiteLoginPath$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteLoginPath$;
/** @constructor */
function $h_Lpresto_types$SiteLoginPath$() {
}
export { $h_Lpresto_types$SiteLoginPath$ as $h_Lpresto_types$SiteLoginPath$ };
$h_Lpresto_types$SiteLoginPath$.prototype = $p;
$p.cHJ = (function() {
  if ((!this.caM)) {
    this.caL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.caM = true;
  }
  return this.caL;
});
$p.iN = (function() {
  if ((!this.caK)) {
    this.caJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.caK = true;
  }
  return this.caJ;
});
$p.cIz = (function() {
  if ((!this.caO)) {
    this.caN = new $j_presto$002etypes$0024$002dSite$002dLogin$002dPath$0024$0024anon$0024124.$c_Lpresto_types$SiteLoginPath$$anon$124(this);
    this.caO = true;
  }
  return this.caN;
});
var $d_Lpresto_types$SiteLoginPath$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteLoginPath$, "presto.types$SiteLoginPath$", ({
  a29: 1,
  D: 1
}));
export { $d_Lpresto_types$SiteLoginPath$ as $d_Lpresto_types$SiteLoginPath$ };
var $n_Lpresto_types$SiteLoginPath$;
function $m_Lpresto_types$SiteLoginPath$() {
  if ((!$n_Lpresto_types$SiteLoginPath$)) {
    $n_Lpresto_types$SiteLoginPath$ = new $c_Lpresto_types$SiteLoginPath$();
  }
  return $n_Lpresto_types$SiteLoginPath$;
}
export { $m_Lpresto_types$SiteLoginPath$ as $m_Lpresto_types$SiteLoginPath$ };
//# sourceMappingURL=presto.types$-Site-Login-Path$.js.map
